module.exports = __webpack_public_path__ + "static/Product-Online-Fullframe-5.d9282d2b.jpg";